import React from "react";
import { useTranslation } from "react-i18next";
import { useTrackingVisited } from "../store/hooks/TrackingHooks";
import PageCentered from "../components/PageCentered";

const FailurePage: React.FC = () => {
    const { t } = useTranslation();
    useTrackingVisited("Failure");

    return <PageCentered title={t("failurePage.title")} message={t("failurePage.message")} />;
};

export default FailurePage;
